import React, { useContext, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

import {
  required,
  validateEmail,
  composeValidators,
} from '../../utils/validation'
import { AppContext } from '../App'

import Heading from '../../components/Heading'
import TextInput from '../../components/TextInput/index'
import Button from '../../components/Button'
import FlexBox from '../../components/Flexbox'
import Select from '../../components/Select/index'

import closeIcon from '../../images/closeIcon-red.svg'
import saveIcon from '../../images/saveIcon.svg'
import HtmlValidationHelper from '../HtmlValidationHelper'

const fieldWidth = 400
const UserForm = (props) => {
  const user = useContext(AppContext)
  const roles = [
    user.userLevel > 5 ||
    (user.userId === props.initialValues?.id && user.userLevel >= 5)
      ? {
          value: 'unitAdmin',
          label: 'Administrator jednostki',
        }
      : {},
    user.userLevel > 3 ||
    (user.userId === props.initialValues?.id && user.userLevel >= 3)
      ? {
          value: 'unitDirector',
          label: 'Dyrektor jednostki',
        }
      : {},
    { value: 'diagnostician', label: 'Diagnosta' },
  ].filter((role) => Object.keys(role).length !== 0)

  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current != null) {
      HtmlValidationHelper.deleteNotAllowedAttributes(formRef.current.node);
    }
  });

  return (
    <Form
      ref={formRef}
      initialValues={props.initialValues}
      mutators={{
        ...arrayMutators,
      }}
      onSubmit={(values) => props.onSubmit(values)}
    >
      {({ handleSubmit, submitting, editable }) => (
        <>
          <FormWrapper>
            <FlexBox direction="column">
              <Field
                component={TextInput}
                width={fieldWidth}
                label="Imię"
                type="text"
                name="firstName"
                validate={required}
                autocomplete='first-name'
              />
              <Field
                width={fieldWidth}
                component={TextInput}
                label="Nazwisko"
                type="text"
                name="lastName"
                validate={required}
                autocomplete='surname'
              />
              <Field
                component={TextInput}
                width={fieldWidth}
                label="Login"
                name="login"
                validate={required}
                autocomplete='login'
                readOnly={props.newModel ? editable : !editable}
              />
              <Field
                component={TextInput}
                width={fieldWidth}
                label="Email"
                name="emailAddress"
                autocomplete='email'
                validate={composeValidators(required, validateEmail)}
              />
              <Field
                width={fieldWidth}
                label="Rola"
                aria-label={"Rola"}
                name="roleNames"
                component={Select}
                options={roles}
                validate={required}
                autocomplete='role'
                isMulti
                noOptionsMessage={() => 'Brak opcji'}
              />
              <FlexBox>
                <Button
                  onClick={() => props.onClose()}
                  label="Zrezygnuj"
                  color="white"
                  icon={closeIcon}
                  altTag=""
                  srText=""
                  imgAriaHidden={true}
                />
                <Button
                  label="Zapisz"
                  marginLeft
                  disabled={submitting}
                  onClick={handleSubmit}
                  icon={saveIcon}
                  altTag=""
                  srText=""
                  imgAriaHidden={true}
                />
              </FlexBox>
            </FlexBox>
          </FormWrapper>
        </>
      )}
    </Form>
  )
}

const FormWrapper = styled.div`
  align-items: start;
  margin: 50px auto 0;
  display: grid;
  grid-gap: 2rem;
  grid: 1fr /1fr 1fr;
  @media (max-width: 700px) {
    grid: 1fr 1fr/1fr;
  }
`

export default UserForm
